import(/* webpackMode: "eager" */ "/var/www/html/frontend/app/(default)/[slug]/error.tsx");
